import React, { useEffect, useState } from 'react';
import classes from "./SearchComponent.module.css"
import { fetchBook,fetchBookCount, getSuggestionsForBestSellerBooks, getSuggestionsForNormalBooks } from '../../../../Store/actions/BookAction';
import { useDispatch } from 'react-redux';
import useScreenSize from '../../../../Hooks/UseScreenSize';
import SearchBarSmall from '../SearchBarSmall/SearchBarSmall';
import { urls } from '../../../../Routes/Urls';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import PrimaryButton from '../../../../Components/Buttons/PrimaryButton/PrimaryButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchengin } from '@fortawesome/free-brands-svg-icons';
import { removeUnpairedQuotes } from '../../../../Util';

const keywords = ["Horror", "Comedy", "Sci-Fi", "Fantasy", "Religion"];

const SearchComponent = () => {
    const [query, setQuery] = useState("");
    const [searchCriteria, setSearchCriteria] = useState("all");
    const [isBestSellerRecommendation,setIsBestSellerRecommendation] = useState(false);

    const history = useHistory()
    const {isSmallScreen} = useScreenSize()

    const handleInputChange = (e) => {
        setQuery(e.target.value);
    };

    const dispatch = useDispatch();

    const handleSearch = async () => {
        if (query === "") return;
        const searchResults = await fetchBook(searchCriteria, query, dispatch);
        const searchCount = await fetchBookCount(searchCriteria,query);
    
        // Redirect to LISTING page with search results as state
        history.push({
            pathname: urls.LISTING,
            search: query ? `?q=${encodeURIComponent(query)}` : "",
            state: { 
                searchResults, 
                searchCount,
                searchCriteria,
                query
            }
        });
    };

    const handleKeyWordSearch = async (keyword) => {
        if(keyword){
            const searchCriteria = "genres";
            const searchResults = await fetchBook(searchCriteria, keyword, dispatch);
            const searchCount = await fetchBookCount(null,null,null,null,[keyword]);
            
            // Redirect to LISTING page with search results as state
            history.push({
                pathname: urls.LISTING,
                state: { 
                    searchResults, 
                    searchCount,
                    searchCriteria,
                    keyword
                }
            });
        }
    }

    const handleKeyPress = (e) => {
        if(e.key === "Enter"){
            handleSearch()
        } else {
          const disallowedCharacters = ["(", "{", "[","]","}",")"];
          if (disallowedCharacters.includes(e.key)) {
            e.preventDefault();
          }
        }
    } 
  
    const handleInputPaste = (e) => {
      e.preventDefault();
    
      const pastedText = e.clipboardData.getData("text").replace(/[\(\)\{\}\[\]]/g, ""); // Remove disallowed characters
      const input = e.target;
      const selectionStart = input.selectionStart;
      const selectionEnd = input.selectionEnd;
    
      const updatedQuery =
        query.substring(0, selectionStart) + pastedText + query.substring(selectionEnd);
    
      setQuery(updatedQuery);
    };

    const [allRecommendations,setAllRecommendations] = useState([])

    const [searchRecommendations,setSearchRecommedations] = useState([]);
    const [recommendationClicked,setRecommendationClicked] = useState(false);
    const [focus,setFocus] = useState(false);
    const [blurTimeout, setBlurTimeout] = useState(null);
  
    const handleRecommendationClick = (recommendation) => {
      setQuery(recommendation?.title)
      setIsBestSellerRecommendation(recommendation?.isBestSeller);
      setSearchRecommedations([]);
      setRecommendationClicked(true);
    };
  
    useEffect(() => {
      if(recommendationClicked) {
        if(!isBestSellerRecommendation) {
          handleSearch();
        } else {
            history.push({
              pathname: urls.BESTSELLER,
              search: query ? `?q=${encodeURIComponent(query)}` : "",
              state: {  
                  query
              }
          });
          setIsBestSellerRecommendation(false)
        }
        setRecommendationClicked(false);
      }
    },[recommendationClicked])
    
    useEffect(() => {
      if (query) {
        const timeout = setTimeout(() => {
          fetchPageData();
          getSuggestionsForNormalBooks(query,"title",10)
        },500);
      
         return () => clearTimeout(timeout);
      }
    }, [query,searchCriteria]);

    useEffect(() => {
        if (query) {
          setSearchRecommedations(
            allRecommendations
          );
        } else {
          setSearchRecommedations([]);
        }
      }, [query, allRecommendations]);

      const handleFocus = () => {
        if (blurTimeout) {
          clearTimeout(blurTimeout); 
        }
        setFocus(true);
      };
    
      const handleBlur = () => {
        const timeout = setTimeout(() => setFocus(false),1000);
        setBlurTimeout(timeout);
      };

      const getFilter = () => {
        let filter = {
          limit: 5,
          offset:0,
          where: {
            $and: [],
          },
        };
    
        if (query) {
            let updatedQuery = removeUnpairedQuotes(query);
            updatedQuery = `"${updatedQuery}"`
            if(searchCriteria === "all") {
              filter.where.$and.push({
                $or: [
                  { author:updatedQuery },
                  { title:updatedQuery },
                  { language:updatedQuery },
                  { sku:updatedQuery },
                  { isbnNo:updatedQuery },
                ],
              });
            } else {
              filter.where.$and.push({
                $or: [
                  { [searchCriteria]:updatedQuery },
                ],
              });
            }
          }
    
        return filter;
      };

      const fetchPageData = async () => {
        if (query !== "") {
          const filter = getFilter();
          const dataBestSeller = await getSuggestionsForBestSellerBooks(
            query,
            searchCriteria,
            5
          );
          
          const data = await getSuggestionsForNormalBooks(
            query,
            searchCriteria,
            5
          );
      
          // Use a case-insensitive approach for deduplication
          const uniqueRecommendations = [];
          const seenValues = new Set(); // This will store lowercase versions for comparison
          const queryLower = query.toLowerCase();
      
          // Process bestseller books
          dataBestSeller?.forEach((book) => {
            if (searchCriteria !== "sku" && searchCriteria !== "isbnNo") {
              // Check author matches
              if (book?.author) {
                const authorLower = book.author.toLowerCase();
                if (authorLower.includes(queryLower) || 
                    queryLower.split(" ").some(word => authorLower.includes(word))) {
                  // Check if we've already seen this author (case-insensitive)
                  if (!seenValues.has(authorLower)) {
                    uniqueRecommendations.push({ title: book.author, isBestSeller: true });
                    seenValues.add(authorLower);
                  }
                }
              }
              
              // Check title matches
              if (book?.title) {
                const titleLower = book.title.toLowerCase();
                if (titleLower.includes(queryLower) || 
                    queryLower.split(" ").some(word => titleLower.includes(word))) {
                  // Check if we've already seen this title (case-insensitive)
                  if (!seenValues.has(titleLower)) {
                    uniqueRecommendations.push({ title: book.title, isBestSeller: true });
                    seenValues.add(titleLower);
                  }
                }
              }
            } else {
              // Check sku and isbnNo for exact matches
              if (book?.sku === query.toLowerCase() && !seenValues.has(book.sku.toLowerCase())) {
                uniqueRecommendations.push({ title: book.sku, isBestSeller: true });
                seenValues.add(book.sku.toLowerCase());
              }
              
              if (book?.isbnNo === query.toLowerCase() && !seenValues.has(book.isbnNo.toLowerCase())) {
                uniqueRecommendations.push({ title: book.isbnNo, isBestSeller: true });
                seenValues.add(book.isbnNo.toLowerCase());
              }
            }
          });
      
          // Process normal books
          data?.forEach((book) => {
            if (searchCriteria !== "sku" && searchCriteria !== "isbnNo") {
              // Check author matches
              if (book?.author) {
                const authorLower = book.author.toLowerCase();
                if (authorLower.includes(queryLower) || 
                    queryLower.split(" ").some(word => authorLower.includes(word))) {
                  // Check if we've already seen this author (case-insensitive)
                  if (!seenValues.has(authorLower)) {
                    uniqueRecommendations.push({ title: book.author, isBestSeller: false });
                    seenValues.add(authorLower);
                  }
                }
              }
              
              // Check title matches
              if (book?.title) {
                const titleLower = book.title.toLowerCase();
                if (titleLower.includes(queryLower) || 
                    queryLower.split(" ").some(word => titleLower.includes(word))) {
                  // Check if we've already seen this title (case-insensitive)
                  if (!seenValues.has(titleLower)) {
                    uniqueRecommendations.push({ title: book.title, isBestSeller: false });
                    seenValues.add(titleLower);
                  }
                }
              }
            } else {
              // Check sku and isbnNo for exact matches
              if (book?.sku === query.toLowerCase() && !seenValues.has(book.sku.toLowerCase())) {
                uniqueRecommendations.push({ title: book.sku, isBestSeller: false });
                seenValues.add(book.sku.toLowerCase());
              }
              
              if (book?.isbnNo === query.toLowerCase() && !seenValues.has(book.isbnNo.toLowerCase())) {
                uniqueRecommendations.push({ title: book.isbnNo, isBestSeller: false });
                seenValues.add(book.isbnNo.toLowerCase());
              }
            }
          });
          
          setAllRecommendations(uniqueRecommendations);
        }
      };

    return (
      <>
        <div className={`${classes.search} ${isSmallScreen ? classes.hidden : ""}`}>
        <div className={`${classes.container} `}>
                  <div className={classes.searchContainer}>
                    <div className={classes.dropdownContainer}>
                      <select
                          name="searchField"
                          id="searchField"
                          required
                          onChange={(e) => setSearchCriteria(e.target.value)}
                      >
                          <option value="all">All</option>
                          <option value="title">Book Title</option>
                          <option value="author">Author</option>
                          <option value="isbnNo">ISBN Number</option>
                          <option value="sku">SKU</option>
                          {/* <option value="keyword">Keyword</option>
                          <option value="ISBN">ISBN</option> */}
                      </select>
                    </div>

                    <input
                        type="text"
                        className={classes.searchInput}
                        placeholder="Search via , Book title, Author"
                        value={query}
                        onChange={handleInputChange}
                        onKeyDown={(e) => handleKeyPress(e)}
                        onFocus={handleFocus}  
                        onBlur={handleBlur} 
                        onPaste={handleInputPaste}
                    />
                    <PrimaryButton className={classes.searchButton} onClick={handleSearch}>
                        Search Now
                    </PrimaryButton>
                  </div>
                  {/* Dropdown with Recommendations */}
                  {searchRecommendations.length > 0 && focus && (
                    <div className={classes.dropdown}>
                    {searchRecommendations?.slice(0,10).map((recommendation, index) => (
                      <div
                        key={index}
                        className={classes.dropdownItem}
                        onClick={() => handleRecommendationClick(recommendation)}
                      >
                        <FontAwesomeIcon icon={faSearchengin}/>
                        {recommendation?.title}
                      </div>
                    ))}
                    </div>
                  )}
              </div>
           
                {/* <SearchBarSmall/> */}
        

            <div className={classes.keywords}>
              {keywords.map((keyword, index) => (
                <span key={index} onClick={() => handleKeyWordSearch(keyword)}>{keyword}</span>
              ))}
            </div>
        </div>
        <div className={isSmallScreen ? "" : classes.hidden} >
            <div className={classes.search}>
              <SearchBarSmall />
            </div>
            <div className={classes.keywords}>
              {keywords.map((keyword, index) => (
                <span key={index} onClick={() => handleKeyWordSearch(keyword)}>{keyword}</span>
              ))}
            </div>
          </div>
        </>
    );
};

export default SearchComponent;
